import { TableState } from '@optimus-web/core';
import { StringFilterType, useRepositoryQuery, UserGroup } from '@mews-commander/data-access';

export const useUserGroupsQuery = ({ pagination, globalFilters, sort }: TableState<UserGroup>) =>
    useRepositoryQuery('userGroups', 'getAll', {
        pagination,
        ...(globalFilters.search && {
            globalSearchFilter: { value: globalFilters.search, filterType: StringFilterType.Contains },
        }),
        sort,
    });
